import React, { useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Target, Trash2, CheckCircle2 } from 'lucide-react';

// Dialog admin : objectif d'une activité (dév. pédagogique...) affectée à un formateur + lecture du réalisé
export const ActiviteHpDialog = ({ open, onOpenChange, hp, typeLabel, formateurNom, onSave, onDelete, saving }) => {
  const [objectif, setObjectif] = useState('');
  useEffect(() => { setObjectif(hp?.objectif || ''); }, [hp]);
  if (!hp) return null;
  const isDP = hp.type_affectation === 'developpement_pedagogique';
  const isNew = !hp.id;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="activite-hp-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <Target className="w-4 h-4 text-blue-600" /> {typeLabel}
          </DialogTitle>
          <p className="text-xs text-slate-500">{formateurNom} · {format(parseISO(hp.date), 'EEEE d MMMM yyyy', { locale: fr })}</p>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label className="text-xs">{isDP ? 'Objectif du développement pédagogique' : 'Consigne / objectif de la journée'}{isDP && <span className="text-red-500"> *</span>}</Label>
            <Textarea value={objectif} onChange={(e) => setObjectif(e.target.value)} rows={4} placeholder={isDP ? 'Ex. : Créer le support et le QCM du module R489 1b…' : 'Optionnel'} className="text-sm" data-testid="hp-objectif" />
            <p className="text-[11px] text-slate-400">Visible par le formateur dans son planning journalier : il y renseignera ce qu'il a réalisé.</p>
          </div>
          {hp.realise ? (
            <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3" data-testid="hp-realise">
              <p className="text-xs font-semibold text-emerald-800 flex items-center gap-1"><CheckCircle2 className="w-3.5 h-3.5" /> Réalisé par le formateur{hp.realise_at ? ` · ${format(parseISO(hp.realise_at), 'dd/MM/yyyy HH:mm')}` : ''}</p>
              <p className="text-sm text-emerald-900 whitespace-pre-wrap mt-1">{hp.realise}</p>
            </div>
          ) : !isNew && (
            <p className="text-[11px] text-slate-400 italic" data-testid="hp-realise-vide">Le formateur n'a pas encore renseigné ce qu'il a réalisé.</p>
          )}
        </div>
        <DialogFooter className="flex items-center gap-2 sm:justify-between">
          {!isNew ? (
            <Button type="button" variant="ghost" size="sm" className="text-red-500 hover:text-red-700 hover:bg-red-50" onClick={() => onDelete(hp.id)} data-testid="hp-delete">
              <Trash2 className="w-3.5 h-3.5 mr-1" /> Supprimer l'affectation
            </Button>
          ) : <span />}
          <div className="flex gap-2">
            <Button type="button" variant="outline" size="sm" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button type="button" size="sm" className="bg-blue-600 hover:bg-blue-700" disabled={saving || (isDP && !objectif.trim())} onClick={() => onSave({ ...hp, objectif: objectif.trim() })} data-testid="hp-save">
              {saving ? 'Enregistrement…' : isNew ? 'Affecter' : 'Enregistrer'}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
